import React from 'react';
import { universities } from '../types/universities';
import { useUniversity } from '../contexts/UniversityContext';

export function UniversitySelector() {
  const { selectedUniversity, setSelectedUniversity } = useUniversity();

  return (
    <select
      value={selectedUniversity.id}
      onChange={(e) => {
        const university = universities.find(u => u.id === e.target.value);
        if (university) setSelectedUniversity(university);
      }}
      className="w-full px-4 py-2 bg-white/10 border border-white/20 rounded-lg
                 text-white text-sm focus:ring-2 hover:bg-white/20 
                 focus:ring-blue-500 focus:border-blue-500 transition-all
                 [&>option]:text-gray-900 [&>option]:bg-white
                 cursor-pointer outline-none appearance-none"
    >
      {universities.map(university => (
        <option key={university.id} value={university.id}>
          {university.name}
        </option>
      ))}
    </select>
  );
}